/*
 * File: EditRules.tsx
 * Project: meryl-sheep
 * -----
 * Last Modified: 06 Oct 2020 11:12:51 am
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { HomeControls } from 'components/molecules/HomeControls';
import { BusinessList } from 'components/organisms/BusinessList';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCompany } from 'redux/slices/appSlice';

export const Home = (): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCompany(''));
  });

  return (
    <Space size={16} direction="vertical">
      <HomeControls />
      <BusinessList />
    </Space>
  );
};
